//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MainInfoColumnBlackAndYellow from './MainInfoColumnBlackAndYellow.vue'
import MainInfoColumnRmsOko from './MainInfoColumnRmsOko.vue'
import MainInfoColumnOverdue from './MainInfoColumnOverdue.vue'
import MainInfoColumnTurn from './MainInfoColumnTurn.vue'
import MainInfoColumnAll from './MainInfoColumnAll.vue'

export default {
  components: {
    MainInfoColumnBlackAndYellow,
    // MainInfoColumnActualization,
    MainInfoColumnRmsOko,
    MainInfoColumnOverdue,
    MainInfoColumnTurn,
    MainInfoColumnAll
  },
  props: {
    sourceClaim: {
      type: Object,
      default: null
    },
    onlyTurn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    columnName: function () {
      return this.sourceClaim && this.sourceClaim.name && this.sourceClaim.name.replace('+ ', '+\n')
    },
    totalTodayHLRouteSource: function () {
      return this.getRouteSourceByType('totalTodayHL')
    },
    blackAndYellowHLRouteSource: function () {
      return this.getRouteSourceByType('blackAndYellowHL')
    },
    rmsOkoHLRouteSource: function () {
      return this.getRouteSourceByType('rmsOkoHL')
    },
    // actualizationHLRouteSource: function () {
    //   return this.getRouteSourceByType('actualizationHL')
    // },
    overdueHLRouteSource: function () {
      return this.getRouteSourceByType('overdueHL')
    },
    turnHLRouteSource: function () {
      return this.getRouteSourceByType('turnHL')
    }
  },
  mounted: function () {
    this.$emit('mounted')
  },
  methods: {
    // getNameFontSize: function (textLength) {
    //   // Две известные точки (x - длина текста, y - размер текста), установлены экспериментально
    //   const x1 = 23; const y1 = 25; const x2 = 31; const y2 = 19
    //   // Линейная интерполяция для вычисления размера шрифта (x = textLength, y = fontSize)
    //   const fontSize = y1 + (y2 - y1) * (textLength - x1) / (x2 - x1)

    //   const maxFontSize = 26
    //   const minFontSize = 14

    //   if (fontSize < minFontSize) {
    //     return minFontSize
    //   } else if (fontSize > maxFontSize) {
    //     return maxFontSize
    //   }
    //   return Math.floor(fontSize)
    // },
    getRouteSourceByType: function (type) {
      return this.sourceClaim && this.sourceClaim.routeSource && this.sourceClaim.routeSource.find(routeSource => routeSource.type && routeSource.type === type) || null
    }
  }
}
